// extracted by mini-css-extract-plugin
export default {"cardIcon":"CardIcon_module-OXJOASIY_cardIcon__-b5VK"};